import styled from 'styled-components'

import Text from 'src/components/Typography/Text'

export const StyledHeader = styled(Text).attrs(() => ({ strong: true }))`
  display: block;
  padding: 6px;
  color: ${({ theme }) => theme.colorTextSecondary};
`
